// extracted by mini-css-extract-plugin
export default {"educationWrapper":"educationWrapper_flZc","lastItem":"lastItem_RbK7","descriptionWrapper":"descriptionWrapper_YzNG","circle":"circle_iFty","date":"date_oC_2","degree":"degree_cRvi"};